var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"popover",rawName:"v-popover",value:(`Your detected time zone: ${_vm.timezone}`),expression:"`Your detected time zone: ${timezone}`"}],staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.utc_offset_string))])
}
var staticRenderFns = []

export { render, staticRenderFns }